<script>
  import Footer from "../../../../../Shared/footer.svelte"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import FilePage from "./Components/filePage.svelte"
  import Counter from "../../Shared/counter2.svelte"
  import axios from "axios"
  import notify from "../../../../../Script/notify"
  import { onMount, onDestroy } from "svelte"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import { tweened } from "svelte/motion"
  import { cubicOut } from "svelte/easing"
  import { flatenObject } from "../../../../../Script/flatenObject"
  import bulkJson from "../../Stores/jsonBulkData"
  import Loader from "../../../../../Shared/Slots/loader.svelte"
  import ConfirmationModal from "../../Shared/confirmationModal.svelte"
  import Tab from "../../Shared/tab.svelte"
  import DocStatusContent from "./Components/docStatusContent.svelte"
  import DynamicFileUploadArea from "./Components/dynamicFileUploadArea.svelte"
  import { isStringifiedObject, loadImage, loadQR } from "../../Script/bulkUpload"
  import DynamicImgList from "./Components/dynamicImgList.svelte"
  import { fetchBulkStatus, fetchBulkTemplate, fetchSelectedDocumentTemp, fetchFileTemplate } from "../../Script/bulkUpload"
  import { loadCSS } from "../../../../../Script/loadLibrary"
  import QRCode from "qrcode"

  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let jsonData = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let fileInProcess = []
  /**
   * @type {"Document Status"|"Preview Generated Documents"|"Dynamic Images"} active tab while generating files
   */
  let activeItem = "Document Status"
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  let activeDoc = "start"
  /**
   * @type {Number} number of files to be generated
   */
  let filesGenerated = 0
  /**
   * @type {Number} number of files to be uploaded
   */
  let filesUploaded = 0
  /**
   * @type {Number} number of files failed to upload
   */
  let failedDocuments = 0
  /**
   * @type {Object}
   */
  let fileData = {}
  /**
   * @type {Number} the total number of documents to be uploaded
   */
  let totalDoc = 0
  /**
   * @type {Number} the count which reflects the increment limit of the progress bar
   */
  let incrementLimit
  /**
   * @type {String} activeColor of the tabs
   */
  let activeColor
  /**
   * @type {Number} initial width of the progress bar
   */
  let width = 0
  /**
   * @type {Boolean} whether to show toggle or not
   */
  let showLoading = false
  /**
   * @type {String} the text to be shown while loading
   */
  let loadingText = "Fetching Bulk Upload data&nbsp;&nbsp;"
  /**
   * @type {Boolean} whether to show confirmation modal for proceeding sign and publish
   */
  let showConfirmationModal = false
  /**
   * @type {Boolean} whether dynamic Files found or not in the associated File template
   */
  let isDynamicFilesFound = false
  /**
   * @type {Array<import("../../Script/document".Tab)>}
   */
  let TabList = [
    { name: "Document Status", icon1: "fa-circle-check", icon2: "fa-clock" },
    { name: "Preview Generated Documents", icon1: "fa-file-check", icon2: "fa-file" },
  ]
  /**
   * @type {Boolean} name of the start button
   */
  let startBtnName = "Start"
  /**
   * Creates a tweened value representing the width of a progress indicator.
   *
   * @param {number} initialValue - The initial value of the tweened width.
   * @param {Object} options - Options for configuring the tween animation.
   * @param {number} options.duration - The duration of the tween animation in milliseconds.
   * @param {function} options.easing - The easing function used for the animation.
   * @returns {Object} - A tweened value object that represents the width of the progress indicator.
   */
  const widthofProgress = tweened(0, {
    duration: 400,
    easing: cubicOut,
  })
  /**
   * @type {Object} stores the query value in the current url
   */
  let query
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  onMount(async () => {
    try {
      // Set showLoading to true to indicate loading state
      showLoading = true

      // Parse the query string into a JavaScript object
      query = queryStringToJSON($querystring)

      // Redirect to the bulk publishing page if the "id" parameter is missing in the query
      if (!query.id) {
        push("/publish/bulk")
        return
      }

      // Fetch data about the bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Redirect based on the status of the bulk publishing
      if (apiData.status == "active" || apiData.status == "published" || apiData.status == "revoked") {
        push(`/documents/bulk/view-report?id=${query.id}`)
        return
      }

      // if (apiData.status == "uploaded") {
      //   push(`/publish/bulk/sign-publish?id=${query.id}`)
      //   return
      // }

      // Redirect to the file upload page if the "generateFile" flag is not set in the API data
      if (!apiData.generateFile) {
        push(`/publish/bulk/upload-file?id=${query.id}`)
        return
      }

      // Fetch data about the bulk template using the "id" from the query
      let bulkData = await fetchBulkTemplate(query.id)

      // Update the $bulkJson array with documents from the fetched bulk data
      $bulkJson = [...bulkData.documents]

      // Set the totalDoc variable to the total number of documents
      totalDoc = $bulkJson.length

      if (apiData.status == "uploaded") {
        fileData.baseUri = `/ipfs/${$bulkJson[0].filename}`
        filesGenerated = filesUploaded = totalDoc
        activeDoc = "completed"
        return
      }

      // Initialize the "isDocumentFailed" property for each document
      for (let i = 0; i < $bulkJson.length; i++) {
        $bulkJson[i].isDocumentFailed = false
      }

      let tobeProcessed = []

      // Filter documents that do not have a "fileHash"
      tobeProcessed = $bulkJson.filter((a) => !a.fileHash)

      // Update the startBtnName based on whether any documents have been processed
      if (tobeProcessed.length != $bulkJson.length) startBtnName = "Resume"

      let alreadyProcessed = $bulkJson.filter((a) => a.fileHash)

      // Fetch data about the document template
      let documentData = await fetchSelectedDocumentTemp(bulkData.bulk.documentTemplate)

      if (documentData) {
        if (!documentData.file) throw "We couldn't find the file template associated with the document template."
        // Fetch file data from the document template
        let dataFromFile = await fetchFileTemplate(documentData.file)

        // Process the file data
        processFileData(dataFromFile)
      }

      // Update counters for generated and uploaded files
      filesGenerated = filesUploaded = $bulkJson.length - tobeProcessed.length

      // Calculate the increment limit for progress
      incrementLimit = 100 / ($bulkJson.length * 2)

      // Change the progress bar width
      changeWidth(filesGenerated + filesUploaded)

      // Reset the "generatedFile" property for documents to be processed
      for (let i = 0; i < tobeProcessed.length; i++) {
        tobeProcessed[i].generatedFile = undefined
      }

      // Update the jsonData array with documents to be processed
      jsonData = [...tobeProcessed]

      // Update the $bulkJson array with documents to be processed and those already processed
      $bulkJson = [...tobeProcessed, ...alreadyProcessed]

      //Gowthaman's code
      if (isDynamicFilesFound) dynamicImageDuplicateRemove()
      //Gowthaman's code
    } catch (error) {
      console.error(error)
      const info = "PAGE: File Generation (Bulk Upload)\nEVENT: onMount"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set showLoading back to false to end the loading state
      showLoading = false
    }
  })

  /**
   * Function for storing the details fetched from the file template
   *
   * @param {Object} dataFromFile - The file data containing information about the file.
   */
  const processFileData = (dataFromFile) => {
    // Extract and store baseUri and layers information from the fetched template data
    fileData.baseUri = dataFromFile.baseUri
    fileData.layers = JSON.parse(dataFromFile.layers)
    fileData.fonts = JSON.parse(dataFromFile.fonts)
    fileData.quality = dataFromFile.quality

    // Filter out layers with dynamic images
    let layerWithDynamicImg = []
    layerWithDynamicImg = fileData.layers.filter((layer) => layer.type == "image" && layer.dynamic)

    // Set a flag indicating whether dynamic files were found
    isDynamicFilesFound = layerWithDynamicImg.length ? true : false

    if (isDynamicFilesFound) {
      TabList = [
        { name: "Document Status", icon1: "fa-circle-check", icon2: "fa-clock" },
        { name: "Dynamic Images", icon1: "fa-image", icon2: "fa-image" },
        { name: "Preview Generated Documents", icon1: "fa-file-check", icon2: "fa-file" },
      ]
    }
  }

  /**
   * Initiates the data processing for the bulk operation.
   * Determines the documents to be processed and triggers further processing steps.
   */
  const initiateProcess = () => {
    // Filter the bulk JSON array to get documents that have not been processed yet (no fileHash)
    let tobeProcessed = $bulkJson.filter((a) => !a.fileHash && !a.isDocumentFailed)

    // Check if there is data in jsonData, documents to be processed, or files in process
    if (jsonData.length || tobeProcessed.length || fileInProcess.length || $bulkJson.length) {
      // Call the function to assign data to the appropriate arrays for further processing
      assignData2Array()
    } else {
      clearInterval(timer)
      console.timeEnd("start") // End the timing for the "initiate" console time
    }
  }

  /**
   * Function for assigning data to respective array
   */
  const assignData2Array = () => {
    // Get the number of available hardware threads or cores
    let hwc = window.navigator.hardwareConcurrency

    // Assign files to the fileInProcess array if it has fewer elements than the available hardware threads
    if (fileInProcess.length < hwc) {
      // Extract a portion of jsonData to fill up to (hwc - fileInProcess.length) elements
      let fArray = jsonData.splice(0, hwc - fileInProcess.length)

      // Add the extracted elements to the fileInProcess array
      fileInProcess = [...fileInProcess, ...fArray]

      // Process each element of fArray by calling the getFileHash function
      for (let i = 0; i < fArray.length; i++) {
        getFileHash(fArray[i])
      }
    }
    // Initiate the process by requesting the next animation frame
    // window.requestAnimationFrame(initiateProcess)
  }

  /**
   * Function for initiate the process for getting fileHash
   * @param {import("../../Script/document").bulkDocument} data
   */
  const getFileHash = async (data) => {
    try {
      // Generate a file from the data object using the 'generateFile' function
      let generatedFile = await generateFile(data)

      // Find the corresponding entry in '$bulkJson' based on its ID
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      tobeUpdated.generatedFile = true

      // Call the 'generateFileHash' function to get the file hash from an API
      let apiData = await generateFileHash(data.id, generatedFile)

      // Update the 'fileHash', 'filename', 'file', and 'state' properties of the corresponding entry
      tobeUpdated.fileHash = apiData.fileHash
      tobeUpdated.filename = apiData.filename

      // increment the 'filesUploaded' counter to keep track of the number of files being uploaded
      filesUploaded++
      changeWidth()

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // $bulkJson = [...$bulkJson.filter((a) => a.id != data.id), tobeUpdated]
    } catch (error) {
      // Find the corresponding entry in '$bulkJson' based on its ID
      // failedDocuments++

      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      tobeUpdated.isDocumentFailed = true
      tobeUpdated.errorMsg = error

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length
      changeWidth()

      // Replace the old entry with the updated one in the '$bulkJson' array
      // $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]
    } finally {
      // Remove the current file entry from the 'fileInProcess' array based on its ID
      fileInProcess = fileInProcess.filter((a) => a.id != data.id)
    }
  }

  /**
   * Function for generating fileHash
   * @param {String} id - its the generated document id
   * @param {File} file - generated file for uploading process
   * @returns {Object|undefined} - Returns the response data or undefined if an error occurs.
   */
  const generateFileHash = async (id, file) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // Send a POST request to the API to generate a file hash and associate it with the document
        const { data } = await axios.patch(
          `/api/swagger/v2/documents/${id}/add-file`,
          {
            file: file,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data", // Set the content type for the request
              "x-access-token": $ApplicationState.token, // Include the access token in the request headers
            },
          }
        )

        // Check if the response has an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode
        }
        resolve(data) // Return the response data
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Function for generating the file using canvas
   * @param {import("../../Script/document").bulkDocument} data
   */
  const generateFile = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // Load the base image from the given 'fileData.baseUri' URL and get its dimensions
        let image = await loadImage(fileData.baseUri)
        let width = image.naturalWidth
        let height = image.naturalHeight

        // Assign the 'fileData.layers' to layers
        let layers = JSON.parse(JSON.stringify(fileData.layers))

        // Create a new canvas element and get its 2D context
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")

        // Set the canvas dimensions to match the dimensions of the base image
        canvas.height = height
        canvas.width = width

        // Draw the base image onto the canvas at (0, 0) with its original width and height
        ctx.drawImage(image, 0, 0, width, height)

        // Flatten the metadata object of 'data' to a one-dimensional object
        let ArrflatObject = flatenObject(JSON.parse(data.metadata))

        let options = JSON.parse(data.options)

        ArrflatObject = { ...ArrflatObject, ...options, documentID: data.id, url: data.url }

        layers = bindLayerValues(ArrflatObject, layers)

        for (let i = 0; i < layers.length; i++) {
          layers[i].attribute = layers[i].attribute.charAt(0).toLowerCase() + layers[i].attribute.slice(1)
        }

        // Load a QR image based on the current timestamp and draw it on the canvas at the top-right corner
        let qr = await loadQR(new Date().toISOString())
        // let qr = await loadQR(data.dateCreated)
        ctx.drawImage(await loadImage(qr), width - 10, 0, 10, 10)

        // Loop through each layer again and render the content based on the layer type (text, image, qr)
        for (let i = 0; i < layers.length; i++) {
          if (layers[i].type == "text") {
            if (layers[i].attribute == "expireOn" && layers[i].value) layers[i].value = new Date(layers[i].value).toDateString().slice(4)
            if (layers[i].attribute == "date") layers[i].value = new Date(layers[i].value).toDateString().slice(4)
            if (layers[i].value && layers[i].value != "text") {
              try {
                layers[i].value = String(layers[i].value).trim()
                await renderText(layers[i], ctx)
              } catch (error) {
                throw `Error : ${error.toString()}; Value: ${layers[i].value}`
              }
            }
          }
          if (layers[i].type == "image") {
            if (layers[i].dynamic) {
              let currentLayer = layers[i].attribute.charAt(0).toLowerCase() + layers[i].attribute.slice(1)
              let imageElement = data.filename[currentLayer]

              let width = layers[i].width
              let height = layers[i].height
              let xPos = layers[i].x
              let yPos = layers[i].y

              let aspectRatio = imageElement.naturalWidth / imageElement.naturalHeight

              if (aspectRatio >= 1) {
                height = Math.floor(layers[i].width / aspectRatio)
                yPos += (layers[i].height - height) / 2
              } else {
                width = Math.floor(layers[i].height * aspectRatio)
                xPos += (layers[i].width - width) / 2
              }

              ctx.drawImage(imageElement, xPos, yPos, width, height)
            } else {
              if (layers[i].src) {
                ctx.drawImage(await loadImage(layers[i].src), layers[i].x, layers[i].y, layers[i].width, layers[i].height)
              }
            }
          }
          if (layers[i].type == "qr") {
            let qr = await QRCode.toDataURL(data.url, {
              color: {
                light: layers[i].bgColor || "#ffffff", // Fully transparent background
                dark: layers[i].color || "#000000", // Black QR code
              },
            })

            // Load a QR image based on 'data.qr' and draw it on the canvas at the specified position and size
            // let qr = await loadQR(data.url)
            ctx.drawImage(await loadImage(qr), layers[i].x, layers[i].y, layers[i].width, layers[i].height)
          }
        }

        const MIN_WIDTH = 800
        const MIN_HEIGHT = 800

        // let ratio = Math.min(MIN_WIDTH / width, MIN_HEIGHT / height)

        let ratio = Math.min(width / MIN_WIDTH, height / MIN_HEIGHT)

        console.log(ratio)

        const newWidth = width / ratio
        const newHeight = height / ratio

        // Create a temp canvas for scaling
        const tempCanvas = document.createElement("canvas")
        const tempCtx = tempCanvas.getContext("2d")

        tempCanvas.width = newWidth
        tempCanvas.height = newHeight

        // Draw scaled image
        tempCtx.drawImage(canvas, 0, 0, newWidth, newHeight)

        // Replace original canvas
        const finalCanvas = tempCanvas

        // Convert the canvas to a Blob object representing the generated image
        let blobObject = await canvasToBlob(finalCanvas)

        // let blobURL = URL.createObjectURL(blobObject)
        // const anchorElem = document.createElement("a")
        // anchorElem.href = blobURL
        // anchorElem.download = `${data.id}.png`
        // anchorElem.click()

        // Convert the canvas to a Blob object representing the generated image
        // let blobObject = await canvasToBlob(canvas)

        // Create a new File object with the Blob and provide a default filename and type
        // let file = new File([blobObject], `${data.id}.jpeg`, {
        //   type: "image/jpeg",
        // })

        let file = new File([blobObject], `${data.id}.png`, {
          type: "image/png",
        })

        filesGenerated++
        changeWidth()

        resolve(file)
      } catch (error) {
        // Return 'undefined' to indicate an error occurred during the generation
        changeWidth()
        reject(error)
      }
    })
  }

  /**
   * Function to load fonts from the given file data
   */
  const loadFonts = async () => {
    try {
      // Iterate through the list of fonts in the fileData
      for (let i = 0; i < fileData.fonts.length; i++) {
        // Call the fetchSingleFont function for each font ID
        let fontData = await fetchSingleFont(fileData.fonts[i])

        await loadCSS(fontData.name, fontData.uri)

        // await loadFontFace(fontData.name, fontData.uri)
      }
    } catch (error) {
      throw error
    }
  }

  // const loadFontFace = (name, uri) => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

  //       const { data } = await axios.get(uri)

  //       let fontList = findFontUrl(data)

  //       console.log("fontList", fontList)

  //       if (fontList.length == 1) {
  //         const normalFont = new FontFace(`${name}-regular`, `url(${fontList[0]})`)
  //         await normalFont.load()
  //         document.fonts.add(normalFont)

  //         const boldFont = new FontFace(`${name}-bold`, `url(${fontList[0]})`, {
  //           weight: "bold",
  //         })
  //         await boldFont.load()
  //         document.fonts.add(boldFont)

  //         await document.fonts.ready
  //       } else {
  //         for (let i = 0; i < fontList.length; i++) {
  //           let subText
  //           if (i == 0) subText = "regular"
  //           else subText = "bold"

  //           const font = new FontFace(`${name}-${subText}`, `url(${fontList[i]})`)
  //           await font.load()
  //           document.fonts.add(font)

  //           await document.fonts.ready
  //         }
  //       }

  //       // let fontUrl = findFontUrl(data)

  //       console.log("fontUrl", fontUrl)

  //       // // Load the font using the FontFace API
  //       // const font = new FontFace(name, `url(${fontUrl})`)
  //       // await font.load()
  //       // document.fonts.add(font)

  //       // // Wait for the font to be fully loaded before using it
  //       // await document.fonts.ready
  //       resolve()
  //     } catch (error) {
  //       // console.error(error)
  //       reject(error)
  //     }
  //   })
  // }

  // const findFontUrl = (data) => {
  //   // Split the CSS data by @font-face rules
  //   const fontFaceChunks = data.split("@font-face")

  //   // Find the chunk containing the @font-face rule with the latin format
  //   let latinFontFaceChunk = fontFaceChunks.filter((chunk) => chunk.includes("U+0000-00FF") && chunk.includes("font-style: normal"))

  //   if (!latinFontFaceChunk) {
  //     latinFontFaceChunk = fontFaceChunks.filter((chunk) => chunk.includes("U+0000-00FF") && chunk.includes("font-style: italic") && (chunk.includes("font-weight: 400") || chunk.includes("font-weight: 700")))
  //     if (!latinFontFaceChunk) throw new Error("Font URL for Latin characters not found in CSS")
  //   } else if (latinFontFaceChunk.length != 1) {
  //     latinFontFaceChunk = fontFaceChunks.filter((chunk) => chunk.includes("font-weight: 400") || chunk.includes("font-weight: 700"))
  //   }

  //   let fontList = []

  //   for (let i = 0; i < latinFontFaceChunk.length; i++) {
  //     const fontUrlMatch = latinFontFaceChunk[i].match(/src: url\((https:\/\/[^)]+)\) format\('woff2'\);/)
  //     console.log(fontUrlMatch, "fontUrlMatch")
  //     fontList.push(fontUrlMatch[1])
  //   }

  //   if (!fontList.length) throw new Error("Font URL not found in CSS")

  //   // Extract the src URL from the found chunk
  //   // const fontUrlMatch = latinFontFaceChunk.match(/src: url\((https:\/\/[^)]+)\) format\('woff2'\);/)
  //   // if (!fontUrlMatch) {
  //   //   throw new Error("Font URL not found in CSS")
  //   // }

  // console.log(fontUrlMatch, "fontUrlMatch")

  //   // const fontUrl = fontUrlMatch[1]

  //   return fontList
  // }

  /**
   * Function to fetch a single font using its ID
   * @param {String} fontID id for the font family
   */
  const fetchSingleFont = (fontID) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // Make a GET request to the API to fetch font data
        const { data } = await axios.get(`/api/swagger/v2/fonts/${fontID}`, {
          headers: {
            "x-access-token": $ApplicationState.token, // Assuming $ApplicationState.token holds the access token
          },
        })

        // Check for errors in the API response
        if (data.error && !data.success) {
          throw data.errorCode // Throw the error code if the API call was not successful
        }

        resolve(data.font)
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Binds values from a flat array to corresponding layers attributes in an array of layers.
   *
   * @param {Object} flatArr - The flat array containing attribute-value pairs.
   * @param {Array} layers - The array of layers with attributes to bind values to.
   * @returns {Array} - An array of layers with updated values bound from the flat array.
   */
  const bindLayerValues = (flatArr, layers) => {
    // Map through the layers and update their values if corresponding attributes exist in the flat array
    layers = layers.map((layer) => {
      if (flatArr[layer.attribute]) {
        layer.value = flatArr[layer.attribute] // Bind the value from flat array to layer's value
      }
      return layer // Return the updated layer
    })

    return [...layers] // Return a new array with the updated layer values
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element to be converted.
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = (canvas) => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob(
        (blob) => {
          // Once the Blob is created, the Promise is resolved with the Blob object.
          resolve(blob)
        },
        "image/png",
        fileData.quality
      )
    })
  }

  /**
   * Renders text on a canvas using the provided data and context.
   *
   * @param {Object} data - The data object containing text rendering information.
   * @param {CanvasRenderingContext2D} ctx - The 2D rendering context of the canvas.
   * @returns {Promise<void>} A promise that resolves when the text is rendered.
   */
  const renderText = (data, ctx) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Check if there are any font styles applied
        if (data.fontStyles.length) {
          data.fontStyles = [...new Set(data.fontStyles)]
          // Convert the fontStyles array to a string and replace commas with spaces
          let fontStyle = data.fontStyles.toString().replaceAll(",", " ")
          // Remove "Underline" from the font style
          fontStyle = fontStyle.replace("Underline", " ")

          await document.fonts.load(`${fontStyle} ${data.fontSize}px '${data.fontFamily}'`)

          // Set the font style for the canvas context using the combined font style, font size, and font family
          ctx.font = `${fontStyle} ${data.fontSize}px '${data.fontFamily}'`
        } else {
          await document.fonts.load(`${data.fontSize}px '${data.fontFamily}'`)
          // If no font styles are applied, set the font size and family directly
          ctx.font = `${data.fontSize}px '${data.fontFamily}'`
        }

        // Set the alignment for the text (left, center, right)
        ctx.textAlign = data.textAlign
        // Set the fill color for the text
        ctx.fillStyle = data.textColor
        // Draw the text on the canvas at the specified coordinates (x, y)
        ctx.fillText(data.value, data.x, data.y)

        if (data.fontStyles.includes("Underline")) {
          let { width, actualBoundingBoxDescent } = ctx.measureText(data.value) // Measure text
          let underlineY = data.y + actualBoundingBoxDescent + 2 // Adjust underline position below text

          if (data.textAlign === "left") {
            ctx.fillRect(data.x, underlineY, width, 3) // Draw underline for left alignment
          } else if (data.textAlign === "center") {
            ctx.fillRect(data.x - width / 2, underlineY, width, 3) // Centered underline
          } else if (data.textAlign === "right") {
            ctx.fillRect(data.x - width, underlineY, width, 3) // Right-aligned underline
          }
        }

        // Resolve the promise to indicate that rendering is complete
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Change the width of a progress bar based on the increment limit.
   * @param {number} times - The number of times to increment the width (default is 1).
   */
  const changeWidth = (times = 1) => {
    // Check if the increment limit exists
    if (incrementLimit) {
      // Increase the width by the increment limit multiplied by the specified number of times
      width = width + incrementLimit * times

      // Set the updated width to a variable called "widthofProgress" using a Svelte reactive statement
      widthofProgress.set(width)

      // Check if the width is rounded to 99% or higher
      if (Math.round(width) >= 99) checkStatus()
    }
  }

  const checkStatus = () => {
    // Check if there are failed documents
    if (failedDocuments) {
      // Check if all documents have been processed or only failed documents remain
      if (totalDoc == filesUploaded + failedDocuments || totalDoc == failedDocuments) {
        // Set the "activeDoc" variable to "retry" to indicate a retry state
        activeDoc = "retry"
      }
      return
    } else {
      // Check if all documents have been successfully processed
      if (totalDoc == filesUploaded) {
        // Set the "activeDoc" variable to "completed" to indicate a completed state
        activeDoc = "completed"
      }
      return
    }
  }

  let timer

  const whileStart = async () => {
    try {
      showLoading = true

      if (fileData.fonts.length) await loadFonts()

      showLoading = false

      // Set the activeDoc status to "processing"
      activeDoc = "processing"

      // Call the initiateProcess function
      // initiateProcess()

      console.time("start")

      timer = setInterval(initiateProcess, 30)
    } catch (error) {
      // console.error(error)
      if (error == "The font you are looking for does not exist.") error = "The font you are looking for does not exist.Kindly update the font in respective file template and continue."
      closeNotification.close()
      const info = "PAGE: File Generation (Bulk Upload)\nEVENT: While initiating bulk file generation process"
      closeNotification = notify.danger(error, info)
      showLoading = false
    }
  }

  onDestroy(() => {
    clearInterval(timer)
  })

  $: changeActiveColor(activeDoc)

  /**
   * Function for changing the active color of the tabs
   * @param {String} activeDoc the current state of the document status
   */
  const changeActiveColor = (activeDoc) => (activeColor = activeDoc == "completed" ? "#22C55E" : "#FF6A00")

  /**
   * Handle actions after uploading dynamic files:
   * - Update document data to indicate dynamic files.
   * - Update tab list and JSON data accordingly.
   */
  const afterUploadingDynamicFiles = () => {
    // Filter documents that do not have a fileHash and are not marked as failed
    let tobeProcessed = $bulkJson.filter((a) => !a.fileHash && !a.isDocumentFailed)

    // Update each document's "dynamic" property to indicate dynamic files using their filenames
    for (let i = 0; i < tobeProcessed.length; i++) {
      tobeProcessed[i].dynamic = tobeProcessed[i].filename
    }

    // Reset the flag indicating dynamic files were found
    isDynamicFilesFound = false

    // Update the tab list to include relevant tabs
    TabList = [
      { name: "Document Status", icon1: "fa-circle-check", icon2: "fa-clock" },
      { name: "Preview Generated Documents", icon1: "fa-file-check", icon2: "fa-file" },
    ]
    activeItem = "Document Status"

    // Update the JSON data with documents that have dynamic files
    jsonData = [...tobeProcessed]
  }

  /**
   * Navigate to the "Sign & Publish" page based on the bulk publishing status.
   */
  const navigateSignPublish = async () => {
    try {
      showLoading = true
      // Fetch bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Check if the bulk publishing status is "uploaded"
      if (apiData.status == "uploaded") showConfirmationModal = true
      // Reload the page if the status is not "uploaded"
      else window.location.reload()
    } catch (error) {
      const info = "PAGE: File Generation (Bulk Upload)\nEVENT: While updating bulk status before navigating to sign and publish page"
      notify.danger(error, info)
      // Redirect to the bulk publishing page in case of an error
      push("/publish/bulk")
    } finally {
      showLoading = false
    }
  }

  //Gowthaman's code
  let totalUploadedSubDoc = 0
  let duplicateImageRemovedArray = []
  const dynamicImageDuplicateRemove = () => {
    duplicateImageRemovedArray = []
    for (let i = 0; i < $bulkJson.length; i++) {
      if (typeof $bulkJson[i].filename == "string") $bulkJson[i].filename = JSON.parse($bulkJson[i].filename)
      let entries = Object.entries($bulkJson[i].filename)
      for (let j = 0; j < entries.length; j++) {
        let obj = {}
        obj.name = entries[j][1]
        obj.upload = false
        obj.image = ""
        if (!duplicateImageRemovedArray.length) duplicateImageRemovedArray = [JSON.stringify(obj)]
        if (!duplicateImageRemovedArray.includes(JSON.stringify(obj))) duplicateImageRemovedArray = [...duplicateImageRemovedArray, JSON.stringify(obj)]
      }
    }

    for (let i = 0; i < duplicateImageRemovedArray.length; i++) {
      duplicateImageRemovedArray[i] = JSON.parse(duplicateImageRemovedArray[i])
    }
  }
</script>

<svelte:head>
  <title>File Generation</title>
</svelte:head>

{#if showConfirmationModal}
  <ConfirmationModal
    title="Confirmation for Sign and Publish"
    content="I have thoroughly reviewed all documents and am prepared to proceed with Signing and Publishing."
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={() => {
      showConfirmationModal = false
      push(`/publish/bulk/sign-publish?id=${query.id}`)
    }}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 {startBtnName == 'Start' && activeDoc == 'start' ? 'pt-6' : 'pt-9'}">
    <!-- <div class="relative mx-auto flex max-h-full min-h-[580px] w-full flex-col justify-between rounded-md bg-white dark:bg-mdGray md:w-4/5 xl:w-3/5"> -->
    <div class="relative mx-auto flex min-h-[470px] w-full max-w-[920px] flex-col justify-between gap-1">
      {#if startBtnName == "Start" && activeDoc == "start"}
        <button on:click={() => push("/publish/bulk")} type="button" class="w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500" style="text-decoration: none;">
          <span>
            <i class="fa-solid fa-reply" />
            <span>&nbsp;Back&nbsp;</span>
          </span>
        </button>
      {/if}
      <div class="flex h-full w-full flex-col justify-between rounded-md bg-white dark:bg-mdGray">
        <Tab {activeColor} bind:activeItem {activeDoc} {TabList} />
        {#if showLoading}
          <div class="flex h-full items-center justify-center text-base text-gray-400">
            <Loader>
              <span class="flex">
                {@html loadingText}
              </span>
            </Loader>
          </div>
        {:else}
          <div class="flex h-full w-full select-none flex-col items-center p-6 mobile:p-12">
            {#if activeItem != "Dynamic Images"}
              <!-- <div class="hidden w-full items-center justify-center gap-6 md:flex">
                <Counter titleText="TOTAL<br>DOCUMENTS" count={totalDoc} innerColor="inset 0px 20px 40px 0px rgba(255, 118, 142, 0.3)" gradient="#ff43c0 0%, #ffa95c 100%" />
                <Counter titleText="GENERATED<br>FILES" count={filesGenerated} innerColor="inset 0px 20px 60px 0px rgba(141,142,255,0.3)" gradient="#0db8ff 0%, #f332ff 100%" />
                <Counter titleText="UPLOADED<br>FILES" count={filesUploaded} innerColor="inset 0px 20px 40px 0px rgba(58,212,173,0.3)" gradient="#39a3ff 0%, #3cff53 100%" />
                <Counter titleText="DOCUMENTS<br>FAILED" count={failedDocuments} innerColor="inset 0px 20px 40px 0px rgba(255,81,47,0.3)" gradient="#FF512F 0%, #DD2476 100%" />
              </div>
              <div class=" flex w-full flex-col justify-center gap-6 md:hidden">
                <Counter titleText="TOTAL<br>DOCUMENTS" count={totalDoc} color="#ff6a00" gradient="#f8a500, #ff6a00" icon="fa-file-lines" />
                <Counter titleText="GENERATED<br>FILES" count={filesGenerated} color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-gear fa-spin" />
                <Counter titleText="UPLOADED<br>FILES" count={filesUploaded} color="#00D515" gradient="#58FE69, #00D515" icon="fa-upload" />
                <Counter titleText="DOCUMENTS<br>FAILED" count={failedDocuments} color="#fe036a" gradient="#f99dbc, #f5347f" icon="fa-file-exclamation" />
              </div> -->
              <div class="grid w-full grid-cols-2 justify-center gap-3 xl:gap-6">
                <Counter titleText="TOTAL DOCUMENTS" count={totalDoc} span="col-span-2" color="#ff6a00" gradient="#f8a500, #ff6a00" icon="fa-file-lines" />
                <Counter titleText="GENERATED FILES" count={filesGenerated} span="col-span-2" color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-gear {activeDoc == 'processing' && totalDoc != filesGenerated ? 'fa-spin' : ''}" />
                <Counter titleText="UPLOADED FILES" count={filesUploaded} span="col-span-2" color="#00D515" gradient="#58FE69, #00D515" icon="fa-upload" />
                <Counter titleText="DOCUMENTS FAILED" count={failedDocuments} span="col-span-2" color="#F03232" gradient="#F87A7A, #F03232" icon="fa-file-exclamation" />
              </div>
            {/if}
            {#if activeItem === "Preview Generated Documents"}
              <FilePage
                {activeDoc}
                baseUri={fileData.baseUri}
                on:docStatus={() => {
                  activeItem = "Document Status"
                }}
                on:sign={navigateSignPublish}
                on:release={(e) => {
                  totalDoc--
                  if (totalDoc == 0) {
                    notify.info("No Documents Left in the bulk Template as you released all document")
                    push("/publish/bulk")
                    return
                  }
                  if (filesGenerated != 0 && e.detail) filesGenerated--
                  // if (filesUploaded != 0) filesUploaded--
                  failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length
                  // failedDocuments--
                  checkStatus()
                }}
              />
            {:else if activeItem == "Dynamic Images"}
              <div class="mb-6 grid w-full grid-cols-2 justify-center gap-3 xl:gap-6">
                <Counter titleText="TOTAL DYNAMIC IMAGES" count={duplicateImageRemovedArray.length} span="col-span-2" color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-file-lines" />
                <Counter titleText="UPLOADED DYNAMIC IMAGES" count={totalUploadedSubDoc} span="col-span-2" color="#00D515" gradient="#58FE69, #00D515" icon="fa-file-lines" />
              </div>

              <div class="flex w-full flex-col justify-between gap-6 sm:flex-row">
                <div class="order-2 w-full sm:order-1 sm:w-1/2">
                  <DynamicImgList bind:fileNames={duplicateImageRemovedArray} />
                </div>
                <div class="order-1 w-full sm:order-2 sm:w-1/2">
                  <DynamicFileUploadArea bind:isDynamicFilesFound bind:duplicateImageRemovedArray bind:totalUploadedSubDoc on:startGenerating={afterUploadingDynamicFiles} />
                </div>
              </div>
            {:else}
              <!-- <div class="mt-6 grid w-full grid-cols-2 gap-3">
                  <Counter titleText="Total<br>Documents" count={totalDoc} gradient="#B589D6,#804FB3" color="#804FB3" />
                  <Counter titleText="Generated<br>Files" count={filesGenerated} gradient="#00a3ff, #4949ff" color="#4949ff" />
                  <Counter titleText="Uploaded<br>Files" count={filesUploaded} gradient="#a1ffa1, #00aa00" color="#00aa00" />
                  <Counter titleText="Document<br>Failed" count={failedDocuments} gradient="#f1959b, #ea4c46" color="#ea4c46" />
                </div> -->

              {#if isDynamicFilesFound}
                <div class="mt-9 flex w-full justify-center text-center text-base text-gray-400">You have dynamic images for this bulk session. Please go to the Dynamic Image section and select the appropriate images for the session.</div>

                <div class="mt-3 flex justify-center">
                  <button on:click={() => (activeItem = "Dynamic Images")} type="button" class="disabled:text-white-200/50 flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-gray-200/50">
                    <span><i class="fa-solid fa-diamond-turn-right" /></span>
                    <span class="hidden select-none md:block">&nbsp;&nbsp;Go&nbsp;to&nbsp;Dynamic&nbsp;Images&nbsp;</span>
                  </button>
                </div>
                <!-- <DynamicFileUploadArea bind:files on:startGenerating={afterUploadingDynamicFiles} /> -->
              {:else}
                <DocStatusContent
                  on:preview={() => {
                    activeItem = "Preview Generated Documents"
                  }}
                  {startBtnName}
                  {activeDoc}
                  width={$widthofProgress}
                  on:start={whileStart}
                  on:click={navigateSignPublish}
                />
              {/if}
            {/if}
          </div>
        {/if}

        {#if activeItem == "Document Status" && activeDoc != "completed"}
          <h1 class="select-none pb-6 text-center text-base font-medium text-red-500 mobile:pb-12">Please don't refresh the page while in progress.</h1>
        {/if}
      </div>
    </div>
  </div>

  <Footer />
</div>
